import React from "react";

const Superworks = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#60B158"
            d="M24.736 7.223c1.403 0 2.54-1.14 2.54-2.544a2.542 2.542 0 0 0-2.54-2.545 2.542 2.542 0 0 0-2.54 2.545 2.542 2.542 0 0 0 2.54 2.544Z"
        />
        <path
            fill="#FF6961"
            d="M11.792 34c1.403 0 2.54-1.14 2.54-2.544a2.542 2.542 0 0 0-2.54-2.545 2.542 2.542 0 0 0-2.54 2.545A2.542 2.542 0 0 0 11.792 34Z"
        />
        <path
            fill="#007AFF"
            d="M17.355 4.99c-.935-.97-.752-2.398-.543-2.99-4.902 2.399-3.803 7.684-2.347 9.497 1.457 1.813 8.574 8.991 10.622 11.013 1.638 1.618 1.56 3.471 1.317 4.196 5.818-3.774 3.13-8.887 1.863-10.3-1.264-1.413-9.735-10.197-10.911-11.414V4.99Z"
        />
        <path
            fill="#FFA700"
            d="M10.125 12.231c-.935-.97-.752-2.397-.544-2.99-4.901 2.4-3.803 7.684-2.347 9.498 1.457 1.813 8.574 8.99 10.622 11.013 1.638 1.618 1.56 3.47 1.316 4.195 5.819-3.774 3.13-8.886 1.864-10.3-1.265-1.412-9.736-10.196-10.911-11.414v-.002Z"
        />
    </svg>
);

export default Superworks;
